var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-cards background-gray"},[_c('MainColumn',[_c('div',{staticClass:"container-left"},[(_vm.blocksLeft)?_c('RenderBlocks',{attrs:{"blocks":_vm.blocksLeft}}):_vm._e()],1),_c('div',{staticClass:"container-right"},[(_vm.blocksRight)?_c('RenderBlocks',{attrs:{"blocks":_vm.blocksRight}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }